export default __webpack_public_path__ + "static/media/888-casino.b4fee474.png";